var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height: ${this.height};`),attrs:{"id":"adobe-dc-view"}})
}
var staticRenderFns = []

export { render, staticRenderFns }